/* @flow */
/* eslint no-unused-vars: 0 */

import React from "react"
import ProductAggregate from "./aggregate"

class ProductAggregations extends React.PureComponent {
  constructor(props) {
    super(props);

    this.state = {
      aggregations: [],
      appliedAggregates: []
    };
    this.formatAggregations = this.formatAggregations.bind(this);
    this.formatAggregationTitle = this.formatAggregationTitle.bind(this);
    this.getDisplayValue = this.getDisplayValue.bind(this);
  }

  componentWillReceiveProps(nextProps) {
    this.formatAggregations(nextProps.aggregations);
  }

  getDisplayValue(type, val) {
    let display = '';
    if (this.props.aggregations[type] !== undefined) {
      let filtered = this.props.aggregations[type].buckets.filter(agg => {
        if (agg.value === val) {
          return agg;
        }
      });
      if (filtered[0] !== undefined) {
        display = filtered[0].key;
      }
    }

    return display;
  }

  formatAggregationTitle(key) {
    return `${key.replace(/_/g, ' ')}`
      .replace('ip ', 'IP ')
      .replace('rcd ', 'RCD ');
  }

  formatAggregations(aggs) {
    let aggregations = [];

    Object.keys(aggs).forEach(key => {
      let options = aggs[key]['buckets'].length;
      if (options >= 1) {
        let formatted_options = [];

        aggs[key]['buckets'].forEach(agg => {
          agg['selected'] = false;

          if (this.props.applied_aggregates[key] !== undefined) {
            if (
              this.props.applied_aggregates[key].includes(
                decodeURIComponent(agg['value'])
              ) === true
            ) {
              agg['selected'] = true;
            }
          }
          formatted_options.push(agg);
        });

        if (this.props.mode !== key) {
          // Don't display brand / category agg if we're in brand / category mode
          aggregations.push({
            title: this.formatAggregationTitle(key),
            options: formatted_options
          });
        }
      }
    });

    aggregations.sort((a, b) => {
      var nameA = a.title.toUpperCase();
      var nameB = b.title.toUpperCase();
      if (nameA < nameB) {
        return -1;
      }
      if (nameA > nameB) {
        return 1;
      }
      return 0;
    });

    this.setState({ aggregations }, function() {
      this.formatAppliedAggregations();
    });
  }

  formatAppliedAggregations() {
    var appliedAggregates = [];
    Object.keys(this.props.applied_aggregates).forEach(key => {
      this.props.applied_aggregates[key].forEach((val, index) => {
        let display_agg_title = val;
        var count = 0;
        if (this.props.aggregations[key] !== undefined) {
          var value = this.props.aggregations[key].buckets.filter(agg => {
            if (key === 'category' || key === 'brand') {
              return agg.value === val;
            } else {
              return agg.key === val;
            }
          });
          count = value[0] === undefined ? 0 : value[0].doc_count;
        }

        if (key === 'brand') {
          display_agg_title = this.getDisplayValue('brand', val);
        }

        if (key === 'category') {
          display_agg_title = this.getDisplayValue('category', val);
        }

        if (count > 0) {
          appliedAggregates.push(
            <li
              onClick={() => {
                this.props.toggleAggregate(key, val, true, true);
              }}
              key={`${val}-${index}`}
            >
              <span>{this.formatAggregationTitle(key)} - </span>
              {decodeURIComponentSafe(display_agg_title)} ({count}){' '}
              <i className="icon-remove-sign" />
            </li>
          );
        } else {
          // Remove any aggregations that are in the URL
          // which don't apply to the current search results
          // only remove aggregates when we have some results.

          if (this.props.products_total > 0) {
            this.props.toggleAggregate(key, val, true, true);
          }
        }
      });
    });

    this.setState({ appliedAggregates: appliedAggregates });
  }

  render() {
    const { close } = this.props.assets.icons;
    const aggsApplied =
      this.state.appliedAggregates.length > 0 ? (
        <ul className="applied--aggregates">{this.state.appliedAggregates}</ul>
      ) : (
        ''
      );

    const clearAggregations =
      Object.keys(this.props.applied_aggregates).length > 0 ? (
        <a
          href="#"
          onClick={e => {
            e.preventDefault();
            this.props.resetAllAggregates();
          }}
        >
          {this.props.mobile_display === true ? 'Clear All Filters' : 'Clear'}
        </a>
      ) : (
        ''
      );
    return (
      <div
        className={
          'product--aggregations ' +
          (this.props.mobile_display === false ? 'hidden-phone' : '')
        }
      >
        <h2>
          Filters
          <img
            alt=""
            src={close}
            className="visible-phone"
            alt=""
            onClick={() => {
              this.props.toggle('display_aggregations');
            }}
            height={20}
            width={20}
          />
          {clearAggregations}
        </h2>
        {aggsApplied}
        {this.state.aggregations.map(agg => (
          <ProductAggregate
            key={agg.title}
            agg={agg}
            assets={this.props.assets}
            toggleAggregate={this.props.toggleAggregate}
          />
        ))}
      </div>
    );
  }
}

export default ProductAggregations;
